export const STYLES = {
    BORDER_RADIUS: '32px',
    BUTTON_BORDER_RADIUS: '25px',
    BUTTON_PADDING: '16px',
    SHADOW: '3px 3px 3px 0px rgb(0, 0, 0, 20%)',
    INPUT_PADDING: '13px',
    BORDER_WIDTH: '2px',
    CONTENT_PADDING_TOP: '50px',
    RADIO: {
        DIMENSION: '27px',
        CHECK_DIMENSION: '17px',
        CHECK_POSITION: '3px',
        GAP: '8px',
        BORDER_WIDTH: '2px',
    },
} as const;

export const FONTS = {
    HEADER_FONT_SIZE: '32px',
    BIG_DESCRIPTION_FONT_SIZE: '18px',
    DESCRIPTION_FONT_SIZE: '14px',
    MEDIUM: 500,
    SEMI_BOLD: 600,
    BOLD: 700,
} as const;

export const COLORS = {
    PINK: '#F4DBDE',
    DARK_GREY: '#414042',
    BUTTON_BACKGROUND: '#F4ADB4',
    WHITE: '#FFF',
} as const;
